import Script from 'next/script';

import { useGlobalECookies } from '@/hooks/useGlobalECookies';
import { GLOBAL_E_MERCHANT_ID, GLOBAL_E_URL } from '@/lib/const';
import { useGlobalEContext } from '@/providers/GlobalEProvider/GlobalEProviderContext';

export function GlobalEScript() {
  const { loadScript, setLoadScript } = useGlobalEContext();

  useGlobalECookies();

  if (!loadScript) {
    return null;
  }

  // This will reset the state of the script so it doesn't load before the cookie on page change
  setLoadScript(false);

  return (
    <Script
      id='external-script'
      onLoad={() => {
        console.log('GLobalE script loaded');
      }}
      src={`//${GLOBAL_E_URL}/includes/js/${GLOBAL_E_MERCHANT_ID}`}
      strategy='lazyOnload'
    />
  );
}
